import { render } from "./FacebookPixel.vue?vue&type=template&id=0a3d19a8"
import script from "./FacebookPixel.vue?vue&type=script&lang=js"
export * from "./FacebookPixel.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__